import React from "react";
import { Box } from "@material-ui/core";
import FreeMessagesWidget from "./FreeMessagesWidget";

/**
 * Example integration component showing how to add FreeMessagesWidget
 * to different parts of the application
 */

// Integration for Sidebar/Navigation
export const SidebarFreeMessagesIntegration: React.FC = () => {
  return (
    <Box style={{ padding: "16px" }}>
      <FreeMessagesWidget />
    </Box>
  );
};

// Integration for Messages Page Header
export const MessagesPageFreeMessagesIntegration: React.FC = () => {
  return (
    <Box style={{ marginBottom: "16px" }}>
      <FreeMessagesWidget />
    </Box>
  );
};

// Integration for Dashboard/Home Page
export const DashboardFreeMessagesIntegration: React.FC = () => {
  return (
    <Box style={{ margin: "16px 0" }}>
      <FreeMessagesWidget />
    </Box>
  );
};

export default {
  SidebarFreeMessagesIntegration,
  MessagesPageFreeMessagesIntegration,
  DashboardFreeMessagesIntegration,
};
